<app-header></app-header>
<app-leftsidebar></app-leftsidebar>

<main class="lp rail-lab">
  <header class="rail-lab-intro">
    <span class="lp-eyebrow">Store rail lab</span>
    <h1 class="rail-lab-title">Every rail density</h1>
    <p class="rail-lab-lede">
      Same store cards as the home page, one rail per layout. Columns stay locked
      so a 5-across rail still shows five tiles here. Hover a card to flip it.
    </p>
    <nav class="rail-lab-jump" aria-label="Jump to a density">
      <a *ngFor="let rail of rails" [href]="'#' + rail.id">{{ rail.titleLead }} {{ rail.titleGold }}</a>
    </nav>
  </header>

  <div *ngFor="let rail of rails; let last = last; trackBy: trackRail" [id]="rail.id">
    <app-store-rail [rail]="rail" [last]="last" [lockColumns]="true"></app-store-rail>
  </div>
</main>

<app-footer></app-footer>
